import { Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LcAClService } from './lc-acl.service';
import { LcACLCanType } from './lc-acl.type';

@Directive({
  selector: '[lcAcl]',
  exportAs: 'lcAcl'
})
export class LcAClDirective implements OnDestroy {
  private _value: LcACLCanType;
  private change$: Subscription;

  @Input('lcAcl')
  set lcAcl(value: LcACLCanType) {
    this.set(value);
  }

  private set(value: LcACLCanType): void {
    this._value = value;
    const CLS = 'lcAcl__hide';
    const el = this.el.nativeElement;
    if (this.srv.can(this._value)) {
      this.renderer.removeClass(el, CLS);
    } else {
      this.renderer.addClass(el, CLS);
    }
  }

  constructor(private el: ElementRef, private renderer: Renderer2, protected srv: LcAClService) {
    this.change$ = this.srv.change.pipe(filter(r => r != null)).subscribe(() => this.set(this._value));
  }

  ngOnDestroy(): void {
    this.change$.unsubscribe();
  }
}
